<template>
<div>

  <v-dialog fullscreen scrollable persistent v-model="dialog">
    <v-card class="pa-5">
      <v-card-title class="py-1">
        <span class="text-h6">Create Sales Order</span>
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog" icon><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-progress-linear :active="mapProductsLoading" :indeterminate="true"/>
      <v-divider></v-divider>

      <v-card-text>
        <v-row class="pt-0">
          <v-col class="px-8" style="border-right: 1px solid #E0E0E0;" cols="3">
            <h1 class="text-h4 mb-15 black--text font-weight-bold mt-2">Order</h1>
            <v-form ref="form">
              <v-autocomplete class="rounded-0" :rules="[v => !!v || 'Customer required']" :items="customers" clearable outlined
                              item-text="name" v-model="selectedCustomer" label="Select Customer*" return-object :filter="customerFilter">
                <template v-slot:item="{item}">
                  <v-list-item-content>
                    <v-list-item-title> {{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>
                      <template v-if="item.Users.length">{{item.Users[0].name}} | </template>
                      {{ item.mobile }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action-text>{{item.Route.name}}</v-list-item-action-text>
                </template>
              </v-autocomplete>
            </v-form>
          </v-col>
          <v-col class="mt-2 px-4" cols="6">
            <div class="mb-10">
              <h1 class="text-h4 black--text font-weight-bold">Products
                <v-text-field outlined dense placeholder="Search Product ..." v-model="search"
                              @input="onSearch" clearable class="float-right"/>
              </h1>
              <h6 class="text-caption font-weight-bold">{{ products.length }} ITEMS</h6>
            </div>
            <div style="height: calc(100vh - 200px); overflow-y: auto;">
            <template v-for="(p, index) in products">
              <v-card class="py-0" :key="index" elevation="0" v-if="!p.isHidden">
                <v-card-text class="py-0 px-0">
                  <v-row>
                    <v-col cols="2" class="text-center px-0 img-div" @click="openGallery([{image: p.image}])">
                      <v-img class="d-block mx-auto"
                             :src="p.image?imgWpx(p.image, 200):'../src/assets/logo.png'"
                             contain height="100"></v-img>
                      <v-chip label text-color="white" x-small v-if="p.packageType" class="mt-3"
                              :style="`background-color: ${packageColor[p.packageType]}`">
                        {{ p.packageType.toUpperCase() }}
                      </v-chip>
                    </v-col>
                    <v-col cols="10">
                      <h6 class="text-h6 font-weight-medium black--text">{{ p.displayName }}</h6>
                      <p class="mb-0">{{spObj[p.id][Box]['quantity']}} {{p.containerType}}es, {{spObj[p.id][Piece]['quantity']}} Pieces</p>
                      <p class="text-caption font-weight-medium mb-0 font-italic">{{ p.noOfPieceInBox }} Pieces in {{p.containerType}}
                        <!--({{ p.priceObj.price | currencyFormatter }})--></p>
                      <div class="mt-5 d-flex align-center"> <!-- v-if="p.isEnable" -->
                        <div>{{p.containerType}}es ({{spObj[p.id][Box].price | currencyFormatter}})
                          <v-text-field style="width: 100px;" class="text-center stock-field rounded-0" append-icon="mdi-plus" dense @change="v => onChangeQuantity(v, p.id, Box)"
                                        @click:prepend-inner="decreaseQuantity(p.id, Box)" @click:append="increaseQuantity(p.id, Box)" @keypress="allowOnlyNumbers"
                                        v-model="quantity[p.id][Box]" flat hide-details outlined prepend-inner-icon="mdi-minus" type="number"/>
                        </div>
                        <div class="ml-4">Pieces ({{spObj[p.id][Piece].price | currencyFormatter}})
                          <v-text-field style="width: 100px;" class="text-center stock-field rounded-0" append-icon="mdi-plus" dense @change="v => onChangeQuantity(v, p.id, Piece)"
                                        @click:prepend-inner="decreaseQuantity(p.id, Piece)" @click:append="increaseQuantity(p.id, Piece)" @keypress="allowOnlyNumbers"
                                        v-model="quantity[p.id][Piece]" flat hide-details outlined prepend-inner-icon="mdi-minus" type="number"/>
                        </div>
                       <!-- <h6 class="text-h6 font-weight-regular ml-5">
                          {{ (p.quantity * p.priceObj.price) | currencyFormatter }}</h6> -->
                      </div>
                     <!-- <div v-else class="red--text font-weight-bold mt-5">No Stock Available</div> -->
                    </v-col>
                    <v-col cols="12" class="pt-6 pb-9">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            </div>
          </v-col>
          <v-col class="px-8" style="border-left: 1px solid #E0E0E0;" cols="3">
            <div class="mb-10 mt-2">
              <h1 class="text-h4 black--text font-weight-bold">Pricing</h1>
              <h6 class="text-caption font-weight-bold">{{totalBoxes}} BOXES ({{totalPieces}} PIECES)</h6>
            </div>

            <div class="d-flex justify-space-between mb-2">
              <span class="text-body-1">Order Amount</span>
              <span class="text-body-1 font-weight-medium">{{ orderForm.totalAmount | currencyFormatter }}</span>
            </div>
            <div class="d-flex justify-space-between mb-2">
              <span class="text-body-1">CGST(2.5%)</span>
              <span class="text-body-1 font-weight-medium">{{ cgst | currencyFormatter }} </span>
            </div>
            <div class="d-flex justify-space-between mb-2">
              <span class="text-body-1">SGST(2.5%)</span>
              <span class="text-body-1 font-weight-medium">{{ cgst | currencyFormatter }} </span>
            </div>
            <div class="d-flex justify-space-between ">
              <span class="text-body-1">Total GST(+5%)</span>
              <span class="text-body-1 font-weight-medium">{{ gst | currencyFormatter }} </span>
            </div>
            <v-divider class="my-3"></v-divider>
            <div class="d-flex justify-space-between green--text mb-14">
              <span class="text-body-1  font-weight-medium">Payable Amount</span>
              <span class="text-body-1  font-weight-medium">{{ finalAmount | currencyFormatter }} </span>
            </div>
            <v-btn block elevation="0" class="py-7 text-capitalize text-body-1 rounded-0" :loading="loading"
                   color="primary" @click="handleSubmit">Place Order</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import moment from 'moment';
import {IDS} from "../../Constants/IDS";
import Constants, {generateUUID} from "../../Constants/Constants";
import {GET_ALL_CUSTOMERS_OF_DISTRIBUTOR} from "../../graphql/queries/Organizations";
import {GET_PRODUCTS_WITH_PRICES_AND_STOCK} from "../../graphql/queries/Products";
import {GET_ORGANIZATION_STOCK_FOR_TRIP} from "../../graphql/queries/PreOrderTrips";
import {ADD_SALES_ORDER} from "../../graphql/mutations/OrderStock";
import Vue from 'vue';
import {allowOnlyNumbers} from "../../util/helpers";
let orderForm = {from: null, to: null, toUserId: null, totalAmount:0, cgst:0, sgst:0, gst:0, finalAmount:0};
let user = JSON.parse(localStorage.user);
let Box = IDS.unitType.Box;
let Piece = IDS.unitType.Piece;
export default {
  name: "CreateSalesOrder",
  props: ['dialog'],
  apollo:{
    RouteShops: {
      query: GET_ALL_CUSTOMERS_OF_DISTRIBUTOR, fetchPolicy: 'network-only',
      skip() { return !this.dialog },
      variables () { return { orgId: user.organizationId } },
      result ({ data }) { this.customers = data.RouteShops.map(shop => ({...shop.Organization, Route:shop.Route})) },
    },
    Products: {
      query: GET_PRODUCTS_WITH_PRICES_AND_STOCK, fetchPolicy: 'network-only',
      skip() { return !this.dialog || !this.selectedCustomer?.priceListId },
      variables () { return { orgId: user.organizationId, priceListId:this.selectedCustomer .priceListId } },
      result ({data}) { this.mapProducts(data.Products) },
    },
  },
  data(){
    return{
      moment, IDS, Constants, Box, Piece, allowOnlyNumbers,
      products: [],
      orderForm: {...orderForm},
      loading: false,
      customers: [],
      selectedCustomer: null,
      spObj: {},                   // stock_price_object (productId.unitId.)
      packageColor: JSON.parse(localStorage.packageColor),
      quantity: {},                // quantity (productId.unitId)
      gstPercent: 5,
      search: '',
      mapProductsLoading: false,
      totalBoxes: 0,
      totalPieces: 0
    }
  },
  computed:{
    cgst: function (){
      return ((this.gstPercent/2)*this.orderForm.totalAmount)/100;
    },
    gst: function (){
      return (this.gstPercent*this.orderForm.totalAmount)/100;
    },
    finalAmount: function(){
      return this.orderForm.totalAmount + this.gst;
    }
  },
  methods:{
    mapProducts(products){
      this.mapProductsLoading = true;
      let spObj = {};
      products.forEach(p => {
        spObj[p.id] = {[Box]:{quantity:0, reservedQuantity:0, originalQuantity:0, price:0},
                       [Piece]:{quantity:0, reservedQuantity:0, originalQuantity:0, price:0},
                       noOfPieceInBox:p['noOfPieceInBox']};
        p.prices.forEach(price => { spObj[p.id][price.unitId]['price'] = price.price });
        p.stocks.forEach(stock => { spObj[p.id][stock.unitId]['quantity'] = stock.quantity;
                                    spObj[p.id][stock.unitId]['originalQuantity'] = stock.quantity;
                                    spObj[p.id][stock.unitId]['reservedQuantity'] = stock.reservedQuantity; });
        let availablePiece = spObj[p.id][Piece].quantity - spObj[p.id][Piece].reservedQuantity;
        let availableBox = spObj[p.id][Box].quantity - spObj[p.id][Box].reservedQuantity;
        if(availablePiece<0 && availableBox>0) {
          spObj[p.id][Box]['quantity'] = availableBox - 1;
          spObj[p.id][Piece]['quantity'] = p['noOfPieceInBox'] + availablePiece;
        } else {
          spObj[p.id][Box]['quantity'] = availableBox;
          spObj[p.id][Piece]['quantity'] = availablePiece;
        }
        this.quantity[p.id] = { [Box]: this.quantity[p.id]?.[Box]||0,
                                [Piece]: this.quantity[p.id]?.[Piece]||0 };
      });
      this.spObj = spObj;
      this.products = JSON.parse(JSON.stringify(products));
      this.mapProductsLoading = false;
    },
    decreaseQuantity(productId, unitId){
      if(this.quantity[productId][unitId] > 0){
        this.quantity[productId][unitId]--;
        this.evaluatePricing();
      }
    },
    increaseQuantity(productId, unitId){
      if(this.quantity[productId][unitId] < this.spObj[productId][unitId].quantity){
        this.handleIncrement(productId, unitId);
      }else if(unitId===Piece && this.quantity[productId][unitId] < this.spObj[productId]['noOfPieceInBox'] &&
          this.quantity[productId][Box] < this.spObj[productId][Box].quantity){
        this.handleIncrement(productId, unitId);
      }
    },
    handleIncrement(productId, unitId){
      this.quantity[productId][unitId]++;
      if(unitId===Piece && this.quantity[productId][unitId]===this.spObj[productId]['noOfPieceInBox']){
        this.quantity[productId][Piece] = 0;
        this.quantity[productId][Box]++;
      }
      this.evaluatePricing();
    },
    validateQuantity(){                             // if found any product with invalid qty return true
      let product = this.products.find(p => {
        let availablePieces = (this.spObj[p.id][Box]['quantity']*this.spObj[p.id]['noOfPieceInBox']) + this.spObj[p.id][Piece]['quantity'];
        let enteredPieces = (this.quantity[p.id][Box]*this.spObj[p.id]['noOfPieceInBox']) + this.quantity[p.id][Piece];
        return (enteredPieces>0 && enteredPieces>availablePieces);
      });
      if(product) {
        this.$emit('showToaster', {enable: true, color: 'red', message: `Invalid quantity entered for Product ${product.displayName}`});
        return true;
      }
    },
    evaluatePricing(){
      this.$forceUpdate();
      let totalAmount = 0, totalBoxes = 0, totalPieces = 0;
      this.products.forEach(p => {
          totalAmount = totalAmount + (this.quantity[p.id][Box]*this.spObj[p.id][Box].price) +
          (this.quantity[p.id][Piece]*this.spObj[p.id][Piece].price);
          totalBoxes = totalBoxes + Number(this.quantity[p.id][Box]);
          totalPieces = totalPieces + Number(this.quantity[p.id][Piece]);
      });
      this.orderForm.totalAmount = totalAmount;
      this.totalBoxes = totalBoxes;
      this.totalPieces = totalPieces;
    },
    onChangeQuantity(val, productId, unitId){
      if(unitId === Piece && val>this.spObj[productId]['noOfPieceInBox']){           //convert pieces to available boxes & pieces
        let totalPieces = Number(val) + (this.quantity[productId][Box]*this.spObj[productId]['noOfPieceInBox']);
        let availablePieces = this.spObj[productId][Piece]['quantity'] + (this.spObj[productId][Box]['quantity']*this.spObj[productId]['noOfPieceInBox']);
        if(totalPieces <= availablePieces){
          this.quantity[productId][Box] = Math.floor(totalPieces/this.spObj[productId]['noOfPieceInBox']);
          this.quantity[productId][Piece] = totalPieces%this.spObj[productId]['noOfPieceInBox'];
        }else {
          this.quantity[productId][Box] = this.spObj[productId][Box]['quantity'];
          this.quantity[productId][Piece] = this.spObj[productId][Piece]['quantity'];
        }
        this.quantity = {...this.quantity};
      }
      this.evaluatePricing();
    },
    customerFilter(item, queryText){
      queryText = queryText.toLowerCase();
      return item.name?.toLowerCase().indexOf(queryText) > -1 || item.mobile?.toLowerCase().indexOf(queryText) > -1 ||
          (item.Users.length&&item.Users[0].name.toLowerCase().indexOf(queryText)>-1);
    },
    onSearch(val){
      val = val?.toLowerCase() || '';
      this.products.forEach(p => Vue.set(p, 'isHidden', p.displayName.toLowerCase().indexOf(val) === -1));
    },
    handleSubmit(){
      if(this.$refs.form.validate()) this.addSalesOrder()
    },
    async addSalesOrder(){
      this.loading = true;
      if(this.validateQuantity()) return this.loading = false;
      this.evaluatePricing();
      if(this.orderForm.totalAmount<1) {
        this.$emit('showToaster', {enable: true, color: 'red', message: `Please enter quantity`});
        return this.loading = false;
      }
      let orderId = generateUUID(), orderItems = [], productIds = [], orgStock = [];
      let commonParameters = {from:user.organizationId, to:this.selectedCustomer.id, createdBy:user.id, updatedBy:user.id};
      this.products.forEach(p => {
        let item = {...commonParameters, orderId, productId:p.id};
        if(this.quantity[p.id][Box]>0) {
          orderItems.push({...item, perUnitPrice: this.spObj[p.id][Box].price.toString(), quantity: this.quantity[p.id][Box],
            unitId: Box, price: (this.quantity[p.id][Box] * this.spObj[p.id][Box].price)});
          productIds.push(p.id);
        }
        if(this.quantity[p.id][Piece]>0) {
          orderItems.push({...item, perUnitPrice:this.spObj[p.id][Piece].price.toString(), quantity:this.quantity[p.id][Piece],
            unitId:Piece, price:(this.quantity[p.id][Piece]*this.spObj[p.id][Piece].price)});
          if(!productIds.includes(p.id)) productIds.push(p.id);
        }
      });
      let response = await this.$apollo.query({
        query: GET_ORGANIZATION_STOCK_FOR_TRIP, fetchPolicy: 'network-only',
        variables: {id: user.organizationId, productIds},
      });
      /* -- Insert missing product stock record (both box & piece records should exists) -- */
      let reverseUnit = {[Box]: Piece, [Piece]: Box};
      productIds.forEach(productId => {
        let pArr = response.data.OrganizationStock.filter(s => s.productId===productId);
        if(pArr.length===1){
          response.data.OrganizationStock.push({...pArr[0], id:generateUUID(), quantity:0, reservedQuantity:0, unitId:reverseUnit[pArr[0].unitId]})
        }
      });
      /* -------------x----------------x----------------x-----------x-----------x----------- */
      // eslint-disable-next-line no-unused-vars
      response.data.OrganizationStock.forEach(({__typename, ...s}) => {
        if(this.quantity[s.productId][Piece] > this.spObj[s.productId][Piece]['originalQuantity']){
          s.quantity = s.unitId===Box?(s.quantity-this.quantity[s.productId][Box]-1):
              (s.quantity+this.spObj[s.productId]['noOfPieceInBox']-this.quantity[s.productId][Piece]);
        }else{
          s.quantity = s.unitId===Box?(s.quantity-this.quantity[s.productId][Box]):
              (s.quantity-this.quantity[s.productId][Piece]);
        }
        orgStock.push(s);
      })
      await this.$apollo.mutate({
        mutation: ADD_SALES_ORDER,
        variables: {
          order: {...commonParameters, id:orderId, date:moment().format(), orderItemCount:orderItems.length,
            status:IDS.TripOrderStatus.Delivered, gstPrice:this.gst.toString(), gstObject:{gst:'5%'}, price:this.orderForm.totalAmount,
            finalPrice:Math.round(this.finalAmount), roundOfValue:this.finalAmount, salesBy:2},
          orderItems, orgStock,
          updateColumnsOrgStock: ['quantity']
        }
      });
      this.loading = false;
      this.$emit('showToaster', { enable: true, color: 'green', message: 'Sales Order created successfully'});
      this.closeDialog();
    },
    closeDialog(){
      this.$refs.form.reset();
      this.orderForm = {...orderForm};
      this.products = [];
      this.quantity = {};
      this.totalBoxes = 0;
      this.totalPieces = 0;
      this.selectedCustomer = null;
      this.search = '';
      this.$emit('update:dialog', false);
    }
  }
}
</script>

<style>
.stock-field input[type=number]::-webkit-inner-spin-button,
.stock-field input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>